// Obscure all but the first and last two characters of a string
export const obscureText = (text) => {
    if (text) {
        return text[0] + text.slice(1).replace(/.(?=.{2,}$)/g, '*');
    }
    return undefined;
};
